module.exports = __webpack_public_path__ + "static/img/card1.6f0559f9.jpg";